import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { ManagerApi } from '@/modules/counterparty/api/manager.api.ts';

export class ManagerQueryOptions {
  static BASE_KEY = 'manager';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, ManagerQueryOptions.BASE_KEY],
      queryFn: (meta) => ManagerApi.getList(signal ?? meta.signal),
    });
  }
}
